import { render, staticRenderFns } from "./SvgProperties.vue?vue&type=template&id=2a32dae2&scoped=true&"
import script from "./SvgProperties.vue?vue&type=script&lang=js&"
export * from "./SvgProperties.vue?vue&type=script&lang=js&"
import style0 from "./SvgProperties.vue?vue&type=style&index=0&id=2a32dae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a32dae2",
  null
  
)

export default component.exports